export const RECOMMENDED_FOR_YOU = 'recommendedForYou';
export const OTHER_GIGS_BY = 'otherGigsBy';
export const RECOMMENDED_IN_SUBCATEGORY = 'recommendedInSubCategory';
export const RECENTLY_VIEWED = 'recentlyViewed';
export const PERSONALIZED_CONTENT_RECOMMENDED_IN_SC = 'personalized_content_recommended_in_sc';

export const CAROUSEL_CONTEXT = 'recommendation';
